module.exports = __webpack_public_path__ + "img/preparing.02572876.png";